import { render, staticRenderFns } from "./relatorio-comandas.vue?vue&type=template&id=1f9538ac&scoped=true"
import script from "./relatorio-comandas.vue?vue&type=script&lang=js"
export * from "./relatorio-comandas.vue?vue&type=script&lang=js"
import style0 from "./relatorio-comandas.vue?vue&type=style&index=0&id=1f9538ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9538ac",
  null
  
)

export default component.exports